import React from "react";

import "./style.less";

const TrackMarker = () => <div className="trackMarker" />;

export default TrackMarker;
